import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { environment } from "../../environments/environment";
import { AuthenticationService } from "../../shared/services/authentication.service";
import { IContact } from "../model/contact.model";
import { Observable, of } from "rxjs";

@Injectable()
export class ContactsService{

    private http = inject(HttpClient);
    authService = inject(AuthenticationService);
    
    sendContact(contact: IContact): Observable<boolean> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.post<boolean>( environment.API_URL + '/api/Contact/Create', contact, options);
        }  
        return of(false);
    }                    
}